export enum InvestmentTypeValue {
  general = '소득적격투자자',
  professional = '전문투자자'
}

export enum InvestmentRequirementKey {
  labor = 'labor',
  business = 'business',
  mixed = 'mixed',
  interest = 'interest',
  online = 'online',
  financial = 'financial'
}

export enum InvestmentRequirementValue {
  labor = '근로소득',
  business = '사업소득',
  mixed = '근로/사업소득',
  interest = '이자, 배당소득',
  online = '온라인 투자경험',
  financial = '금융전문가'
}

export enum InvestmentQualifications {
  ordinary = 'ordinary',
  accredited = 'accredited',
  professional = 'professional'
}

export enum InvestmentQualificationsValue {
  ordinary = '일반투자자',
  accredited = '소득적격투자자',
  professional = '전문투자자'
}

export enum InvestmentQualificationsLevel {
  ordinary = 0,
  accredited,
  professional
}
